export const ServiceList = [{
        id: 1,
        title: "HTTP Proxy",
        icons: "http",
        description: "Velit, viverra lorem elit hendrerit orci elementum. Enim nascetur dictum mattis urna amet, non. Tortor proin non leo."
    },
    {
        id: 2,
        title: "SOCKSV5",
        icons: "socks",
        description: "Velit, viverra lorem elit hendrerit orci elementum. Enim nascetur dictum mattis urna amet, non. Tortor proin non leo."
    },
    {
        id: 3,
        title: "Dedicated Proxies",
        icons: "dedicated",
        description: "Velit, viverra lorem elit hendrerit orci elementum. Enim nascetur dictum mattis urna amet, non. Tortor proin non leo."
    },
    {
        id: 4,
        title: "Shared Proxies",
        icons: "shared",
        description: "Velit, viverra lorem elit hendrerit orci elementum. Enim nascetur dictum mattis urna amet, non. Tortor proin non leo."
    }
];